import { render, staticRenderFns } from "./TicketReportsContainer.vue?vue&type=template&id=59610306&"
import script from "./TicketReportsContainer.vue?vue&type=script&lang=ts&"
export * from "./TicketReportsContainer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports